import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UsersService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) { }

    getUsers(): Observable<any> {
        const url = `${environment.api}/user`;
        return this.http.get<Observable<any>>(url);
    }

    getUser(userId: number): Observable<any> {
        const url = `${environment.api}/user/${userId}`;
        return this.http.get<Observable<any>>(url);
    }

    getCurrentUser(): Observable<any> {
        const url = `${environment.api}/user/current`;
        return this.http.get<Observable<any>>(url);
    }

    createUser(body): Observable<any> {
        const url = `${environment.api}/user/create`;
        return this.http.post<Observable<any>>(url, body);
    }

    blockUser(userId: number, blocked: boolean): Observable<any> {
        let params = new HttpParams();
        params = params.set('blocked', String(blocked));
        const url = `${environment.api}/user/${userId}`;
        return this.http.post<Observable<any>>(url, {}, { params });
    }
    
    legitimateUser(userId: number, legitimated: boolean): Observable<any> {
        let params = new HttpParams();
        params = params.set('legitimated', String(legitimated));
        const url = `${environment.api}/user/${userId}`;
        return this.http.post<Observable<any>>(url, {}, { params });
    }

    resetPassword(email: string): Observable<any> {
        let params = new HttpParams();
        params = params.set('email', email);
        const url = `${environment.api}/user/reset_password`;
        return this.http.post<Observable<any>>(url, {}, { params });
    }

    updateUser(userId: number, body): Observable<any> {
        const url = `${environment.api}/user/${userId}`;
        return this.http.put<Observable<any>>(url, body);
    }

    updateCurrentUser(body): Observable<any> {
        const url = `${environment.api}/user/current`;
        return this.http.put<Observable<any>>(url, body);
    }

    changePassword(token: string, email: string, body: any) {
        let params = new HttpParams();
        params = params.set('email', email);
        params = params.set('token', token);
        const url = `${environment.api}/user/change_password`;
        return this.http.put<Observable<any>>(url, body, { params });
    }

    updatePassword(body): Observable<any> {
        const url = `${environment.api}/user/update_password`;
        return this.http.put<Observable<any>>(url, body);
    }
}